import { useMutation } from '@tanstack/react-query';

import { RiskAssessmentsApi } from 'api/RiskAssessmentsApi';
import { RISK_ASSESSMENTS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';
import { downloadFileFromSignedUrl } from 'util/files.util';

export function useExportRiskAssessmentPdf() {
  const riskAssessmentsApi = new RiskAssessmentsApi();
  const { userBankId } = useUser();

  // mutate, not mutateAsync: nothing awaits the download, and a rejected promise nobody catches
  // surfaces as an unhandled rejection alongside the meta snackbar.
  const { mutate: exportRiskAssessmentPdf, isPending: isExportingRiskAssessmentPdf } = useMutation({
    mutationKey: [RISK_ASSESSMENTS_KEY, 'export-pdf'],
    mutationFn: (id: string) => riskAssessmentsApi.exportRiskAssessmentPdf(userBankId, id),
    onSuccess: ({ signedUrl }) => downloadFileFromSignedUrl(signedUrl),
    meta: {
      snackbarErrorMessage: 'There was an issue exporting the risk assessment. Please contact support.'
    }
  });

  return { exportRiskAssessmentPdf, isExportingRiskAssessmentPdf };
}
